<template lang="html">
  <div class="comment" v-if="insight_theme_content.length != 0">
    <img :src="$store.state.static_img_url+'mobile/pic/xiaosanjiao.png'">
    <div class="item" v-for="i in insight_theme_content" :key="i.id">
      <i class="iconfont lt">&#xe6be;</i>
      <p>
        {{i.content}}
        <!-- <span>(动脉⽹编辑{{i.create_user_name}},供⾏业⼈人⼠参考)</span> -->
      </p>
      <i class="iconfont rb">&#xe6bf;</i>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list', 'rowid'],
  computed: {
    insight_theme_content() {
      return this.list.filter(item => item.module_theme_id == this.rowid) || []
    }
  }
}
</script>

<style lang="stylus" scoped>
.comment
  margin-top: .40rem;
  padding: .3rem;
  background: #FFFAF6;
  position: relative;
  img
    width: .50rem;
    height: .25rem;
    position: absolute;
    top: -.25rem;
    left: .25rem;
  .item
    position: relative;
    i
      font-size: .28rem;
      color: #FFD9B9;
      position: absolute;
      line-height: .44rem;
    i.lt
      top: 0;
      left: 0;
    i.rb
      bottom: 0;
      right: 0;
    p
      font-size: .28rem;
      color: #555555;
      line-height: .44rem;
      margin:0 .44rem;
      span
        color: #999
  .item+.item
    border-top: 1px solid #f3f3f3;
    margin-top: .4rem;
    padding-top: .4rem;
    i.lt
      top: .4rem;
</style>
